import { cx } from "@/lib/cx";

/**
 * Rollup of a parent's children: a ring filled to done/total in the completed-status colour, with
 * the fraction always available as text (label or accessible name). Size 14 in rows, 16 in headers.
 */
export function ProgressRing({
  done,
  total,
  size = 14,
  label,
  className,
}: {
  done: number;
  total: number;
  size?: number;
  /** Accessible name, e.g. "3 of 5 done". */
  label: string;
  className?: string;
}) {
  const stroke = 2;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const frac = total > 0 ? Math.min(1, done / total) : 0;
  return (
    <span role="img" aria-label={label} title={label} className={cx("inline-flex shrink-0", className)}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true" className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="var(--line-strong)"
          strokeOpacity={0.45}
          strokeWidth={stroke}
        />
        {frac > 0 ? (
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke="var(--status-completed)"
            strokeWidth={stroke}
            strokeDasharray={`${c * frac} ${c}`}
            strokeLinecap={frac >= 1 ? "butt" : "round"}
          />
        ) : null}
      </svg>
    </span>
  );
}
